const ctx = require.context("../../lang", false, /\.json$/, "lazy");
export const availableLocales = ctx
    .keys()
    .map((k) => k.replace(/^\.\//, "").replace(/\.json$/, ""))
    .sort();
export function isLocale(v) {
    return typeof v === "string" && availableLocales.includes(v);
}
// loadDict — граница безопасности: путь в чанк собирается только из уже проверенного
// значения availableLocales, никогда из сырого ввода (§11 спеки — иначе path traversal).
export async function loadDict(locale) {
    if (!isLocale(locale))
        throw new Error(`i18n: неизвестная локаль "${locale}"`);
    const mod = (await ctx(`./${locale}.json`));
    return mod.default ?? mod;
}
